import {type BannerAssessment} from '../assessments-banner/assessments-banner-card.react-component';
import {PopQuizRecommendedAssessment} from './types';

function selectPrimaryDomainId(assessment: BannerAssessment): string | null {
    const domains = (assessment.domains ?? []).filter((domain) => domain != null);
    if (domains.length === 0) {
        return null;
    }
    const highestWeighted = domains.reduce((best, domain) =>
        (domain.weight ?? -Infinity) > (best.weight ?? -Infinity) ? domain : best,
    );
    return highestWeighted.id;
}

/**
 * Maps a raw `BannerAssessment` (the assessments-catalog GQL shape, shared with the sibling
 * Assessments Banner feature) into Pop Quiz's own `PopQuizRecommendedAssessment` shape.
 */
export function mapRecommendedAssessment(
    assessment: BannerAssessment,
): PopQuizRecommendedAssessment {
    return {
        id: assessment.id,
        title: assessment.title,
        urlLanding: assessment.urlLanding,
        isBeta: assessment.isBeta,
        isActive: assessment.isActive,
        topicIds: (assessment.topics ?? [])
            .filter((topic) => topic != null)
            .map((topic) => topic.id),
        domainId: selectPrimaryDomainId(assessment),
    };
}
